<template>
	<div
		class="p-3 row mt-5"
		:style="'background-image: url('+require('../../assets/img/bg_light_orange.svg')+');'"
		style="
		background-repeat: no-repeat;
		background-position: top;
		background-size: cover;
		border-radius: 30px;
		"
	>
		<div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 text-center">
			<img
				alt="مشارکت در آموزش"
				title="مشارکت در آموزش"
				:src="require('../../assets/img/love.svg')"
				class="w-50"
			/>
		</div>
		<div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
			<p class="text-justify">
				به بخش کمک‌های مردمی سامانه‌ی استاد بین خوش آمدید. شما از این قسمت می‌توانید با پرداخت کمک‌های نقدی، به هموطنان و فارسی زبانان سراسر جهان یاری رسانده تا افراد نیازمند یا مهاجران نیز بتوانند از خدمات آموزشی سامانه‌ی ایزی تیک بهره ببرند.
				مبالغ پرداختی توسط شما نیکوکاران گرامی در بخش مددکاری محفوظ مانده و پس از بررسی درخواست مددجویان، حمایت‌های لازم به عمل خواهد آمد، که به واسطه‌ی حمایت‌های شما مقدور گردیده است و نتیجه آن به اطلاع شما خواهد رسید.
			</p>
			<div class="row">
				<div class="col-sm-6 col-md-6 col-lg-4 col-xl-4 mb-3">
					<btn
						class=""
						style_btn="float: inline-start; width: 100%;"
						text="ثبت درخواست"
						@clickMe="(e)=>{ this.$emit('show_page'); }"
					/>
				</div>
				<div 
				class="col-sm-6 col-md-6 col-lg-4 col-xl-4 mb-3">
					<btn
					type="outline-success"
					class=""
					text="بازگشت"
					style_btn="width:100%; "
					@clickMe="$router.go(-1)"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import textInput from  "../../UI/input/textInput.vue";
		import multiSelectInput from  "../../UI/input/multiSelectInput.vue";
		import selectInput from  "../../UI/input/selectInput.vue";
		import textareaInput from  "../../UI/input/textareaInput.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import previewImage from  "../../UI/uploadFile/previewImage.vue";
		import uploadFile from  "../../UI/uploadFile/file.vue";
		import { validateEmail, validatePhone, indexFinder } from  "../../assets/library/filter.js";
		import { success, error, loading, success_sm } from  "../../assets/library/messege.js";

		export default {
			name: 'participation_in_education',
			data(){
				return {
					validateEmail: validateEmail,
					validatePhone: validatePhone,
					indexFinder: indexFinder,
					success: success,
					success_sm: success_sm,
					error: error,
					loading: loading,
					imgurl: window.imgurl,
					baseurl: window.baseurl,
					val:{
						money: '50000',
						nam: '',
						exp: '',
						phone: '',
					},
					index_text : -1,
				}
			},
			components: {
				btn,
				uploadFile,
				validateEmail,
				validateEmail,
				textInput,
				selectInput,
				pageNavigation,
				userImg,
				previewImage,
				textareaInput,
				multiSelectInput,
			},
			props: {

			},
			mounted(THIS = this){
				var url = new URL(location.href);
				var Status = url.searchParams.get("Status");

				if(Status=="OK"){
					THIS.success(THIS);
				}else if(Status=="NOK"){
					THIS.error(THIS, "پرداخت با موفقیت انجام نشده است");
				}
				this.index_text = this.indexFinder(this.$localStorage.get('settings'), "15");
			},
			methods:{
				//______________________________________________________________________
				sav(THIS = this){
					if(this.val.money=="" || parseInt(this.val.money) < 50000){
						THIS.error(THIS, 'حداقل مبلغ مجاز برای ثیت در خیریه پنجاه هزار تومان است');
						this.val.money = "50000";
					} else {
						this.savF();
					}
				},
				//______________________________________________________________________
				savF(THIS = this){
					THIS.loading(THIS);
					window.$.post(this.baseurl + 'charity/save', {
						token: this.$localStorage.get("user"),
						val: this.val,
					}, function(D){
						if(D.ok){
							let r_url = "api.ticket.siadat.net"
							if(window.location.host=="dev.ticket.siadat.net"){
								r_url = "devapi.ticket.siadat.net"
							}else if(window.location.host=="sand.ticket.siadat.net"){
								r_url = "sandapi.ticket.siadat.net"
							}else {
								r_url = "api.ticket.siadat.net" 
							}
							window.location.href = location.origin+"/api_UTadris/prdOnline_charity.php?id="+D.data+ "&mobile="+THIS.$localStorage.get('mobile')+"&url="+ r_url;
						}
					}, "json");
				},
				//______________________________________________________________________
			}
		}
	</script>
